// Product type categories from Shopify
export const PRODUCT_TYPES = [
  "AV Accessories",
  "Accessories",
  "Accordion",
  "Acoustic Guitars",
  "Adapter",
  "Amplifiers",
  "Antenna Splitter",
  "Audio Cable",
  "Audio Converter",
  "Audio Interface",
  "Audio Player",
  "Audio Recorder",
  "Audio Sampler",
  "Automation Controller",
  "Bass Amplifier",
  "Bass Guitars",
  "Blu-Ray Player",
  "Brass Instruments",
  "Breaker",
  "Broadcast Accessory",
  "CCTV Equipment",
  "CD",
  "CD Players",
  "CD Ripper",
  "CDs",
  "Cables",
  "Camcorder",
  "Camera Accessories",
  "Cassette Deck",
  "Cassette Tape",
  "Components",
  "Computer Components",
  "Computers",
  "Converter",
  "DJ Controller",
  "DJ Equipment",
  "DVD Player",
  "DVD Rewriter",
  "DVD Writer",
  "Dash Camera",
  "Devices",
  "Digital System",
  "Disk Drive",
  "Diskette",
  "Dobro",
  "Drum Amplifier",
  "Drum Box",
  "Drum Hardware",
  "Drum Machine",
  "Drum Part",
  "Drums",
  "E-reader",
  "Effect Processor",
  "Effect Unit Racks",
  "Effects Pedal",
  "Electric Guitar Boxes",
  "Electric Guitar Pickups",
  "Electric Guitars",
  "Electrical works",
  "Electronic Drum Part",
  "Electronic Instruments",
  "Entertainment",
  "Equalisers",
  "Flight Cases",
  "Floppy Disc",
  "Footswitch",
  "Glockenspiel",
  "Guitar Accessories",
  "Guitar Amplifiers",
  "Guitar Case",
  "Guitar Pedal",
  "Guitar Pickups",
  "Guitar Stand",
  "Handheld Device",
  "Headphones",
  "Hi-Fi",
  "Hi-Fi Amplifiers",
  "Hi-Fi Receivers",
  "Hi-Fi Speakers",
  "Hi-Fi Tuner",
  "Instrument Amplifiers",
  "Karaoke System",
  "Keyboard Amplifiers",
  "Keyboard Pedals",
  "Keyboard Stand",
  "Keyboards",
  "Lighting and Effects",
  "Lights",
  "MIDI Interface",
  "Mandolin",
  "Manuals",
  "Master Tape",
  "Matrix Switcher",
  "Media Player",
  "Metronome",
  "Microdiscs",
  "Microphone",
  "Microphone Accessories",
  "Microphone Stand",
  "Microphone System",
  "Midi Controller",
  "Midi Device",
  "Mini-Disc",
  "Mini-Disc Player",
  "Mixer",
  "Monitor",
  "Multitrack Recorders",
  "Music Production",
  "Musical Keyboards",
  "Networking",
  "PA Gear",
  "PA Speakers",
  "PC Monitor",
  "Pedal Board",
  "Piano",
  "Power Amplifiers",
  "Power Meter",
  "Power Supply",
  "Pre-Amplifier",
  "Preamps",
  "Pro Audio",
  "Projectors",
  "Racks and Cases",
  "Radio",
  "Receiver",
  "Reel to Reel Record",
  "Reel to Reel Recorder",
  "Remote",
  "Sampler",
  "Saxophone",
  "Sequencer",
  "Server",
  "Software",
  "Sound Card",
  "Sound Module",
  "Spares or Repair",
  "Speaker Accessory",
  "Speaker Stands",
  "Speakerphone",
  "Speakers",
  "Spectrum Analyser",
  "Stage",
  "String Instruments",
  "Studio Gear",
  "Studio Monitors",
  "Subwoofers",
  "Switcher",
  "Synthesizer",
  "Synthesizer Keyboards",
  "Synthesizer Module",
  "TV",
  "Tape reel",
  "Testing Unit",
  "Transmitter",
  "Tripod Stand",
  "Tuner",
  "Turntable",
  "VHS",
  "Valves",
  "Video Camera",
  "Video Recorder",
  "Vinyl",
  "Wall Mount",
  "Wind Instrument",
  "Xylophone"
]

// Extract search term from title (everything before first " - ")
export const getSearchTerm = (title) => {
  if (!title) return ''
  const dashIndex = title.indexOf(' - ')
  return dashIndex > 0 ? title.substring(0, dashIndex) : title
}

// Generate search URLs for external marketplaces
export const getSearchUrls = (title) => {
  const term = encodeURIComponent(getSearchTerm(title))
  return {
    reverbSold: `https://reverb.com/uk/marketplace?query=${term}&show_only_sold=true`,
    ebayActive: `https://www.ebay.co.uk/sch/i.html?_nkw=${term}&_sacat=0&LH_BIN=1&_dmd=2&rt=nc`,
    ebaySold: `https://www.ebay.co.uk/sch/i.html?_nkw=${term}&_sacat=0&LH_Complete=1&LH_Sold=1&rt=nc&LH_BIN=1&_dmd=2&rt=nc`,
    google: `https://www.google.com/search?q=${term}`
  }
}

// Open search in new window
export const openSearchWindow = (url) => {
  window.open(url, '_blank', 'width=1200,height=800')
}

// Shopify admin URL
export const SHOPIFY_ADMIN_URL = 'https://admin.shopify.com/store/143c34'
